<template>
  <form :id="widgetType" @submit.prevent="addNewWidget">

    <CommunInputs :widgetConfig="widgetConfig"></CommunInputs>

    <label class="form-label">Unidad</label>
    <input
      class="form-control"
      v-model="widgetConfig.unit"
      type="text"
      required
    />

    <label class="form-label">Cantidad de decimales</label>
    <input
      class="form-control"
      v-model.number="widgetConfig.decimalPlaces"
      label=""
      type="number"
      @input="validateCount(widgetConfig)"
      required
    />
    <label class="form-label">Icono</label>

    <IconsForm :value="widgetConfig"></IconsForm>

    <label for="" class="form-label">Seleccionar Color</label>
    <select
      v-model="widgetConfig.class"
      class="form-select"
      placeholder="Seleccionar color"
      style="width: 100%"
      required
    >
      <option class="text-success" value="success" label="Verde"></option>
      <option class="text-primary" value="primary" label="Azul"></option>
      <option class="text-warning" value="warning" label="Amarillo"></option>
      <option class="text-danger" value="danger" label="Rojo"></option>
    </select>

  </form>
</template>
<script>
import IconsForm from './IconsForm.vue';
import CommunInputs from './common/CommunInputs.vue';
export default {

  props: ["widgetConfig", "addNewWidget", "validateCount","widgetType"],
  components:{
    IconsForm,
    CommunInputs
  }
}
</script>
